import { render, staticRenderFns } from "./DeleteVat.vue?vue&type=template&id=3dd00959"
import script from "./DeleteVat.vue?vue&type=script&lang=js"
export * from "./DeleteVat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports